import React, { useEffect, useRef, useState } from "react";
import { RotateCw } from "lucide-react";

const OUT = 1200; const PV = 300;

const draw = (ctx, size, img, s) => {
  ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, size, size);
  const k = size / PV; const turned = s.rot % 180 !== 0;
  const iw = turned ? img.height : img.width; const ih = turned ? img.width : img.height;
  const base = Math.max(size / iw, size / ih) * s.zoom;
  ctx.save();
  ctx.filter = `brightness(${s.bright}%) contrast(${s.contrast}%)`;
  ctx.translate(size / 2 + s.x * k, size / 2 + s.y * k); ctx.rotate((s.rot * Math.PI) / 180); ctx.scale(base, base);
  ctx.drawImage(img, -img.width / 2, -img.height / 2);
  ctx.restore();
};

const Slider = ({ label, id, v, min, max, step, set }) => (
  <label className="block text-xs text-slate-600">{label}
    <input type="range" data-testid={`photo-edit-${id}`} min={min} max={max} step={step} value={v} onChange={(e) => set(+e.target.value)} className="w-full accent-slate-900" />
  </label>
);

export const PhotoEditor = ({ file, onDone, onCancel }) => {
  const cv = useRef(null); const drag = useRef(null);
  const [img, setImg] = useState(null);
  const [s, setS] = useState({ zoom: 1, rot: 0, bright: 100, contrast: 100, x: 0, y: 0 });
  useEffect(() => { const u = URL.createObjectURL(file); const i = new Image(); i.onload = () => setImg(i); i.src = u; return () => URL.revokeObjectURL(u); }, [file]);
  useEffect(() => { if (img && cv.current) { draw(cv.current.getContext("2d"), PV, img, s); } }, [img, s]);
  const set = (k) => (v) => setS((o) => ({ ...o, [k]: v }));
  const down = (e) => { drag.current = { px: e.clientX, py: e.clientY, x: s.x, y: s.y }; e.currentTarget.setPointerCapture(e.pointerId); };
  const move = (e) => { const d = drag.current; if (d) { setS((o) => ({ ...o, x: d.x + e.clientX - d.px, y: d.y + e.clientY - d.py })); } };
  const save = () => { const c = document.createElement("canvas"); c.width = c.height = OUT; draw(c.getContext("2d"), OUT, img, s); c.toBlob((b) => onDone(b), "image/jpeg", 0.85); };
  return (
    <div className="fixed inset-0 z-[70] bg-black/60 grid place-items-center p-4" data-testid="photo-editor">
      <div className="bg-white rounded-2xl p-4 w-full max-w-sm space-y-3">
        <b className="text-sm">Edit foto produk</b>
        <canvas ref={cv} width={PV} height={PV} onPointerDown={down} onPointerMove={move} onPointerUp={() => { drag.current = null; }} className="w-full aspect-square rounded-xl border border-slate-200 cursor-move touch-none" data-testid="photo-edit-canvas" />
        <p className="text-[11px] text-slate-400">Geser foto untuk mengatur posisi. Hasil dipotong kotak & dikecilkan otomatis.</p>
        <Slider label="Perbesar" id="zoom" v={s.zoom} min={1} max={3} step={0.01} set={set("zoom")} />
        <Slider label="Terang" id="bright" v={s.bright} min={50} max={150} step={1} set={set("bright")} />
        <Slider label="Kontras" id="contrast" v={s.contrast} min={50} max={150} step={1} set={set("contrast")} />
        <div className="flex gap-2">
          <button type="button" data-testid="photo-edit-rotate" onClick={() => set("rot")((s.rot + 90) % 360)} className="px-3 py-2 rounded-lg border border-slate-300 text-sm inline-flex items-center gap-1"><RotateCw className="w-4 h-4" /> Putar</button>
          <button type="button" data-testid="photo-edit-cancel" onClick={onCancel} className="ml-auto px-3 py-2 rounded-lg border border-slate-300 text-sm">Batal</button>
          <button type="button" data-testid="photo-edit-save" disabled={!img} onClick={save} className="px-4 py-2 rounded-lg bg-slate-900 text-white text-sm disabled:opacity-50">Pakai foto</button>
        </div>
      </div>
    </div>
  );
};
